import theme from "@/theme";
import { SxProps, Theme } from "@mui/material";

export const styles: Record<string, SxProps<Theme>> = {
  container: {
    width: "100%",
    // minHeight: "298px",
    padding: " 0 20px 16px 20px",
    borderBottom: "2px solid  #f7f7f7",
  },
  avatar: {
    width: 104,
    height: 104,
  },
  buttonBox: {
    height: "36px",
    display: "flex",
    gap: "14px",
    lineHeight: "24px",
  },

  buttonEdit: {
    padding: "7px 18px",
    height: "36px",
    width: "89px",
    borderColor: theme.palette.custom.mainBlue,
    color: theme.palette.custom.mainBlue,
    textTransform: "none",
    fontWeight: 500,
    fontSize: "16px",
    borderRadius: "26px",
    whiteSpace: "nowrap",
    fontFamily: "Poppins, sans-serif",
    lineHeight: "24px !important",
    "& .MuiButton-startIcon": {
      marginRight: "1px",
    },
    "& .MuiButton-label": {
      lineHeight: "24px",
    },
  },

  buttonBuyFocuslist: {
    height: "40px",
    padding: "8px 16px",
    borderRadius: "26px",
    backgroundColor: "#2A85FF33",
    color: theme.palette.custom.mainBlue,
    textTransform: "none",
    fontWeight: 500,
    fontSize: "16px",
    fontFamily: "Poppins, sans-serif",
    lineHeight: "100%",
    letterSpacing: "0em",
    border: "none",
  },

  buttonFollow: {
    height: "36px",
    width: "100px",
    padding: "8px 20px",
    borderRadius: "26px",
    backgroundColor: theme.palette.custom.mainBlue,
    color: "#FFFFFF",
    textTransform: "none",
    fontWeight: 500,
    fontSize: "16px",
    fontFamily: "Poppins, sans-serif",
    lineHeight: "100%",
    letterSpacing: "0em",
    border: "none",
  },

  buttonSendZap: {
    height: "36px",
    padding: "7px 12px 7px 8px",
    borderRadius: "26px",
    backgroundColor: "#fffbeb",
    color: "#7b3306",
    textTransform: "none",

    border: "1px solid #fee685",
    marginRight: "14px",

    textAlign: "start",
  },
  svgSendZap: {
    fontWeight: 500,
    fontSize: "15px",
    fontFamily: "Inter, sans-serif",
    lineHeight: "20px",
    letterSpacing: "-2%",
  },

  chipMetric: {
    height: "26px",
    padding: "2px 6px 2px 2px ",
    backgroundColor: "#8BC5F41A",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "133%",
    textAlign: "right",
    color: "#000000",
    "& .MuiChip-icon": {
      marginLeft: 0,
    },
    "& .MuiChip-label": {
      paddingLeft: "0px",
      paddingRight: "0px",
    },
  },
  dollarMetric: {
    height: "26px",
    padding: "2px 6px 2px 5px ",
    backgroundColor: "#8BC5F41A",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "133%",
    textAlign: "right",
    color: "#000000",
    "& .MuiChip-icon": {
      marginLeft: 0,
      marginRight: 0,
    },
    "& .MuiChip-label": {
      paddingLeft: "3px",
      paddingRight: "0px",
    },
  },
  chipTop: {
    minWidth: "59px",
    maxWidth: "100px",
    height: "22px",
    padding: "1px 4px",
    borderRadius: "5px",
    backgroundColor: "#2AAAFF1A",
    gap: "10px",
    margin: "0 0 0 4px",
    "& .MuiChip-label": {
      height: "20px",
      fontFamily: "Poppins, sans-serif",
      fontWeight: 600,
      fontSize: "13px",
      lineHeight: "20px",
      letterSpacing: "-0.02em",
      color: theme.palette.custom.mainBlue,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 0,
    },
  },
  username: {
    display: "block",
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "15px",
    lineHeight: "160%",
    letterSpacing: "0em",
    color: "#2A2D31",
    marginRight: "4px",
  },
  bioText: {
    width: "100%",
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "18px",
    letterSpacing: "0em",
    color: "#2A2D31",
    marginBottom: "4px",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
  },

  bioHighlight: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "18px",
    letterSpacing: "0em",
    color: theme.palette.custom.mainBlue,
    display: "inline",
    cursor: "pointer",
  },
  memberTranding: {
    height: "18px",
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: "13px",
    lineHeight: "154%",
    letterSpacing: "0em",
    color: "#7D8690",
    display: "flex",
    alignItems: "center",
    gap: "2px",
  },
  memberMentors: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: "13px",
    lineHeight: "20px",
    letterSpacing: "0em",
    color: "#7D8690",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "4px",
  },
  memberSince: {
    height: "18px",
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: "13px",
    lineHeight: "154%",
    letterSpacing: "0em",
    color: "#7D8690",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  tradingText: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: "13px",
    lineHeight: "20px",
    letterSpacing: "0em",
    color: "#7D8690",
    mt: 1,
    // margin: "10px 0 5px 0",
  },
  tradingMentors: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "18px",
    letterSpacing: "0em",
    color: "#7D8690",
    margin: "5px 0",
  },
  mentorTag: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "18px",
    letterSpacing: "0em",
    color: theme.palette.custom.mainBlue,
    display: "inline",
    cursor: "pointer",
  },
  svgIcon: {
    width: 12.83,
    height: 12.83,
    opacity: 1,
    top: "0",
    left: "0",
    borderWidth: "1.5px",
  },
};
